import createManualEntityChoice from './createManualEntityChoice';

// Special terms the admin hasn't typed yet: none, or an emptied rich text
// editor (e.g. "<p></p>", "<p>&nbsp;</p>"), like PurchaseOrder#special_terms=
const isBlankHtml = (html?: string | null): boolean =>
  (html ?? '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|\u00a0/g, '')
    .trim() === '';

const withManualExpertChoice = createManualEntityChoice({
  manualId: 'nouveau',
  resource: 'users',
  searchFilter: { kind: 'expert' },
  activeFieldName: 'expert_manual_active',
  manualChoiceLabelKey:
    'resource.purchase_orders.field.expert_id.choices.manual_expert.label',
  fieldLabelKey: 'resource.purchase_orders.field.expert_id.label',
  getOptionLabel: (item) => item.full_name,
  // "Modalités particulières – héritage": prefill this purchase order's
  // special terms with the expert's company's default ones, unless the
  // admin has already typed some
  onSelectReal: async (val, form, dataProvider) => {
    if (!isBlankHtml(form.getState().values.special_terms)) return;

    try {
      const { data: user } = await dataProvider.getOne('users', { id: val });

      let legal = user?.company?.legal_information;
      if (!legal && user?.company?.legal_information_id) {
        const { data } = await dataProvider.getOne('legal_informations', {
          id: user.company.legal_information_id,
        });
        legal = data;
      }

      form.change('special_terms', legal?.special_terms || '');
    } catch (e) {
      console.error("Failed to pre-fill the expert's special terms", e);
    }
  },
  onSelectManual: (form) => {
    [
      'expert_attributes.first_name',
      'expert_attributes.last_name',
      'expert_attributes.email',
    ].forEach((f) => form.change(f, ''));
  },
});

export default withManualExpertChoice;
